import React, { useEffect, useState } from "react";
import axios from "axios";
import DocumentCard from "./DocumentCard";
import { useParams } from "react-router-dom";

const DocumentList = () => {
  const [docs, setDocs] = useState([]);
  const {id}=useParams()
  const fetchDocs = async () => {
    const res = await axios.get("https://gantasoft.in/cab-g/dev/driver/v1/documents_list_web.php?driver_id="+id);
    if (res.data.success) {
      setDocs(res.data.items);
    }
  };

  useEffect(() => {
    fetchDocs();
  }, []);

  return (
    <div className="flex flex-wrap gap-4">
      {docs.map((doc) => (
        <DocumentCard key={doc.type} doc={doc} onStatusChange={fetchDocs} />
      ))}
    </div>
  );
};

export default DocumentList;